import React from 'react';
import { Button, Card, Text } from '@fragments';
import { IconAlertTriangle, IconCreditCard, IconCreditCardOff, IconLogin, IconRefresh, IconUserPlus } from '@tabler/icons-react';
import PlanSummary from './components/PlanSummary';
import BalanceCard from './components/BalanceCard';
import PaymentMethodCard from './components/PaymentMethodCard';
import InvoiceList from './components/InvoiceList';
import CancelDialog from './components/CancelDialog';
import usePlanPage from './hooks/usePlanPage';
import { STUDIO_HOME } from '../../enums/routes';
import './styles.scss';

// /studio/plan — "Gerenciar assinaturas" in the account menu, and where the core's emails
// and Stripe's card portal return: the plan in force, the balance, the card on file and
// the invoices, as one bento (plan | balance over card) above the invoice list. Scrolls
// inside the shell, under the header's blur.
export default function Plan({ studio: s }) {
  const { t } = s;
  const page = usePlanPage(s);
  const state = (icon, text, action) => <div className="studio-plan-page__state">
    <span className="studio-plan-page__state-icon" aria-hidden="true">{icon}</span>
    <Text.p contrast={7}>{text}</Text.p>
    {action}
  </div>;

  const body = page.loading ? <div className="studio-plan-page__bento" aria-busy="true">
      <div className="studio-plan-page__main"><Card split>
        <Text.subheading loading>{t('billingPlanEyebrow')}</Text.subheading>
        <Text.h2 loading>{t('billingTitle')}</Text.h2>
        <Text.p loading>{t('billingSubtitle')}</Text.p>
      </Card></div>
      <div className="studio-plan-page__side">
        <Card split><Text.subheading loading>{t('billingBalanceEyebrow')}</Text.subheading><Text.h3 loading>{t('billingBalanceEyebrow')}</Text.h3></Card>
        <Card split><Text.subheading loading>{t('billingCardEyebrow')}</Text.subheading><Text.label loading>{t('billingCardEyebrow')}</Text.label></Card>
      </div>
    </div>
    : !s.auth.signed ? state(<IconLogin />, t('billingSignIn'),
      <Button variant="rounded" color="inverse" onClick={s.goToLogin}>{t('login')}</Button>)
    : page.needsProfile ? state(<IconUserPlus />, t('billingNeedsProfile'),
      <Button variant="rounded" color="inverse" onClick={() => s.navigate(STUDIO_HOME)}>{t('trendingConnectProfile')}</Button>)
    : page.unavailable ? state(<IconCreditCardOff />, t('error_payments'))
    : page.failed ? state(<IconAlertTriangle />, t('billingLoadError'),
      <Button variant="rounded" color="overlay" startIcon={<IconRefresh />} onClick={page.retry}>{t('retry')}</Button>)
    : <>
      <div className="studio-plan-page__bento">
        <div className="studio-plan-page__main"><PlanSummary studio={s} page={page} /></div>
        <div className="studio-plan-page__side">
          <BalanceCard studio={s} />
          <PaymentMethodCard studio={s} page={page} />
        </div>
      </div>
      <InvoiceList studio={s} page={page} />
    </>;

  return <div className="studio-plan-page">
    <div className="studio-plan-page__inner">
      <header className="studio-plan-page__head">
        <Text.caption contrast={6} left={<IconCreditCard />}>{t('billingEyebrow')}</Text.caption>
        <Text.h2 weight={400} contrast={9}>{t('billingTitle')}</Text.h2>
        <Text.p contrast={7}>{t('billingSubtitle')}</Text.p>
      </header>
      {body}
    </div>
    {page.confirming && page.live && <CancelDialog studio={s} page={page} />}
  </div>;
}
